import * as React from 'react'
import { styled } from 'next-yak'

import { Icon } from '../Icon'
import { type SpecificIconProps } from '../types'
import { lightweight, standalone, type SymbolProps } from '../../spritesheetUtils'

const ID = 'mondialrelay-third-party-glyph-icon'

export function MondialRelaySymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <path fill="none" d="M0 0h32v32H0z" />
      <path
        d="M24.5 5.4c-2.8-.4-5.6-.7-8.5-.7-2.9 0-5.7.3-8.5.7C6.1 5.8 5.1 7 5 8.5v15c.1 1.5 1.1 2.7 2.5 3.1 2.8.4 5.7.7 8.5.7 2.9-.1 5.7-.3 8.5-.7 1.4-.4 2.4-1.6 2.5-3.1v-15c-.1-1.5-1.1-2.7-2.5-3.1z"
        fill="#96154a"
      />
      <path
        d="M11.6 17.9v5.7l3-1.9v-3.8c0-1.6 1.3-2.6 3.1-2.3v-2.8c-3.8-.4-6.1 1.8-6.1 5.1zm3.4-6.3c.9 0 1.7-.8 1.7-1.7 0-.9-.8-1.7-1.7-1.7-.9 0-1.7.8-1.7 1.7 0 1 .8 1.7 1.7 1.7z"
        fill="#fff"
      />
      <path
        d="M18.4 15.4c0 .2.2.4.4.4.4.1.8.1 1.2.1.4 0 .8 0 1.2-.1.2-.1.3-.2.4-.4v-2.2c0-.2-.2-.4-.4-.4-.4-.1-.8-.1-1.2-.1-.4 0-.8 0-1.2.1-.2.1-.4.2-.4.4v2.2z"
        fill="#f6abb6"
      />
    </symbol>
  )
}

const FacebookStandaloneContent = standalone(MondialRelaySymbol, ID)

export const MondialRelay = styled(function MondialRelayStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="mondial-relay">
      <FacebookStandaloneContent />
    </Icon>
  )
})``

export const MondialRelayLightweight = styled(function MondialRelayComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="mondial-relay-light-weight">
      {lightweight(ID)}
    </Icon>
  )
})``
